import { PollCursor } from '../../_utils/poll-cursor.util'

export interface LocationPollResponse {
  data: {
    columns: any
    location: any
    sessions: any
  }
  cursor?: PollCursor
  backfilling: boolean
  id: number
  done: boolean
}

export interface LocationPollErrorResponse {
  text: string
}

export enum LocationPollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
  Backfill = 5,
}

export enum LocationPollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
